<template>
  <el-form
    ref="ruleForm"
    :model="item"
    label-position="left"
    label-width="160px"
  >
    <el-form-item label="Full-Screen" prop="use_fullscreen" required>
      <el-switch v-model="item.use_fullscreen"></el-switch>
    </el-form-item>
    <form-item-group
      title="Images"
      :min="CONSTANT.CREATIVE_DEFAULT_VALUE.PARALLAX_SCROLLING.MIN_NUM"
      :max="CONSTANT.CREATIVE_DEFAULT_VALUE.PARALLAX_SCROLLING.MAX_NUM"
      :group-item="CONSTANT.CREATIVE_DEFAULT_VALUE.PARALLAX_SCROLLING.ITEM"
      v-model="item.images"
    >
      <template slot-scope="{ index }">
        <el-row type="flex" justify="space-between" :gutter="10">
          <el-col>
            <el-form-item label="Material Mode">
              <el-radio-group
                v-model="item.images[index].material_type"
                @change="clearUrl(index)"
              >
                <el-radio :label="CONSTANT.MATERIAL_TYPE.IMAGES"
                  >Images</el-radio
                >
                <el-radio :label="CONSTANT.MATERIAL_TYPE.HTML">Html</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              :label="switchMaterialType(index).label"
              :prop="`images.${index}.url`"
              label-width="120px"
              :rules="
                item.images[index].material_type ===
                CONSTANT.MATERIAL_TYPE.IMAGES
                  ? [
                      ...imageRatioRule(ratio_size.image),
                      ...urlRule('image_url'),
                    ]
                  : urlRule('html_url')
              "
            >
              <file-input
                :accept="switchMaterialType(index).accept"
                v-model="item.images[index].url"
                :check_upload_image_ratio="{
                  ...ratio_size.image,
                  enable:
                    item.images[index].material_type ===
                    CONSTANT.MATERIAL_TYPE.IMAGES,
                }"
              ></file-input>
            </el-form-item>
            <div
              v-show="
                item.images[index].material_type === CONSTANT.MATERIAL_TYPE.HTML
              "
            >
              <el-form-item label="Html play time">
                <el-input-number
                  v-model="item.images[index].millisecond"
                  :step="1000"
                  :min="0"
                  :max="99000"
                  :disabled="
                    item.images[index].material_type ===
                      CONSTANT.MATERIAL_TYPE.IMAGES
                  "
                ></el-input-number>
                <span> millisecond</span>
              </el-form-item>
              <el-form-item label="Loop">
                <el-switch v-model="item.images[index].loop"
                  >Loop Html play</el-switch
                >
              </el-form-item>
              <el-form-item label="Times">
                <el-input-number
                  v-model="item.images[index].times"
                  :step="1"
                  :min="0"
                  :max="9999"
                  :disabled="
                    item.images[index].material_type ===
                      CONSTANT.MATERIAL_TYPE.IMAGES ||
                      item.images[index].loop === true
                  "
                ></el-input-number>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="4" v-if="withOutstream">
            <el-radio v-model="item.video.index" :label="index" border
              >video</el-radio
            >
          </el-col>
        </el-row>
      </template>
    </form-item-group>
    <video-item
      ref="video"
      replay
      v-if="withOutstream"
      :use-facebook-livestream="true"
    >
      <video-size
        :is-facebook-livestream="isFaceBookLiveStream"
        ref="videoSize"
        v-model="item.video"
        :max-width="320"
        :max-height="480"
      ></video-size>
    </video-item>
  </el-form>
</template>

<script>
import MixFormRule from "@/components/mixins/formRule";
import MixCreativeForm from "@/components/mixins/creativeForm";

const { PARALLAX_SCROLLING } = CONSTANT.CREATIVE_DEFAULT_VALUE;

export default {
  data() {
    return {
      item: {
        images: [...Array(PARALLAX_SCROLLING.MIN_NUM)].map(() =>
          _.cloneDeep(PARALLAX_SCROLLING.ITEM)
        ),
        use_fullscreen: false,
        video: {
          index: 0,
          width: 320,
          height: 180,
          vertical: {
            align: "center",
            padding: 0,
          },
          horizontal: {
            align: "center",
            padding: 0,
          },
        },
      },
      withOutstream: _.includes(this.value._type, "WithOutstream"),
      ratio_size: {
        image: {
          width: 320,
          height: 480,
        },
      },
      isMounted: false,
    };
  },
  mixins: [MixFormRule, MixCreativeForm],
  mounted() {
    this.isMounted = true;
  },
  computed: {
    isFaceBookLiveStream() {
      if (!this.isMounted) return;
      return this.$refs.video.item.type === "facebook_video_url";
    },
  },
  methods: {
    clearUrl(index) {
      this.item.images[index].url = "";
    },
    switchMaterialType(index) {
      let imagesObj = {};
      if (
        this.item.images[index].material_type === CONSTANT.MATERIAL_TYPE.HTML
      ) {
        imagesObj.label = "Html";
        imagesObj.accept =
          "application/zip, application/x-zip-compressed, application/zip-compressed";
      } else {
        imagesObj.label = "Image";
        imagesObj.accept = "image/jpeg, image/png, image/gif";
      }
      return imagesObj;
    },
    setData(row) {
      this.item.images = _.map(row.images, (image) => {
        let result = {
          material_type: image.material_type,
          url: decodeURI(image.url),
        };
        if (image.material_type === CONSTANT.MATERIAL_TYPE.HTML) {
          result.millisecond = image.millisecond;
          if (image.times === -1) {
            result.loop = true;
          } else {
            result.loop = false;
          }
          result.times = image.times;
        }
        return result;
      });
      this.item.use_fullscreen = row.use_fullscreen;

      if (this.withOutstream) {
        this.item.video.height = row.video_height;
        this.item.video.width = row.video_width;
        this.item.video.index = row.video_index;
        _.forEach(["vertical"], (key) => {
          this.item.video[key].align = row[`${key}_align`];
          if (row[`${key}_align`] !== "center") {
            this.item.video[key].padding = row[`${key}_padding`];
          }
        });
        this.$refs.video.setData(row);
      }
    },
    async getData(setObj) {
      setObj.images = _.map(this.item.images, (image) => {
        let result = {
          material_type: image.material_type,
          url: image.url.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)),
        };
        if (image.material_type === CONSTANT.MATERIAL_TYPE.HTML) {
          result.millisecond = image.millisecond;
          if (image.loop) {
            result.times = -1;
          } else {
            result.times = image.times;
          }
        }
        return result;
      });
      setObj.use_fullscreen = this.item.use_fullscreen;

      if (this.withOutstream) {
        setObj = await this.$refs.video.getData(setObj, 320, 180);
        const video = this.item.video;
        setObj.video_height = video.height;
        setObj.video_width = video.width;
        setObj.video_index = video.index;
        _.forEach(["vertical"], (key) => {
          setObj[`${key}_align`] = video[key].align;
          if (video[key].align !== "center") {
            setObj[`${key}_padding`] = video[key].padding;
          }
        });
      }

      return setObj;
    },
  },
};
</script>

<style></style>
